export const validateForm = (formState: any) => {
  const newErrors: any = {};

  if (!formState.teamName) {
    newErrors.teamName = "Team name is required";
  } else if (formState.teamName.length < 2 || formState.teamName.length > 50) {
    newErrors.teamName = "Team name must be between 2-50 characters";
  } else if (!/^[a-zA-Z0-9\s-]+$/.test(formState.teamName)) {
    newErrors.teamName = "Team name can only contain letters, numbers, spaces, and hyphens";
  }

  if (formState.reminderMethod === 'sms') {
    if (!formState.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required when SMS is selected";
    } else if (!/^\+\d{5,15}$/.test(formState.phoneNumber)) {
      newErrors.phoneNumber = "Please enter a valid international phone number starting with +";
    }
  }

  if (formState.reminderMethod === 'telegram') {
    if (!formState.telegramChatId) {
      newErrors.telegramChatId = "Telegram chat ID is required when Telegram is selected";
    } else if (!/^\d+$/.test(formState.telegramChatId)) {
      newErrors.telegramChatId = "Telegram chat ID must contain only numbers";
    }
  }

  return newErrors;
};
